import { URLS } from "../../../commun/routes.tsx";
import { useAppContext } from "../../components/App/AppProvider.tsx";
import { PageContent } from "../../components/Elements/Elements.tsx";
import PageTitle from "../../components/Elements/PageTitle/PageTitle.tsx";
import { IconUsers } from "../../components/Icon/Icon.tsx";
import EditColumn, {
  ActiveDesactiveColumn,
} from "../../components/Table/columns.tsx";
import QueryTableWithFilter from "../../components/Table/QueryTableWithFilter.tsx";
import { RoleEntity } from "../../Entities/RoleEntity.tsx";
import { UtilisateurEntity } from "../../Entities/UtilisateurEntity.tsx";
import url from "../../module/fetch.tsx";
import FilterUtilisateurs, {
  filterValuesToVariable,
  initialFilterValues,
} from "./FilterUtilisateur.tsx";

const ListUtilisateurs = () => {
  const { user }: { user: UtilisateurEntity } = useAppContext();
  return (
    <>
      <PageTitle icon={<IconUsers />} title="Gestion des utilisateurs" />
      <PageContent>
        <QueryTableWithFilter
          idName="utilisateurs"
          query={url`/api/utilisateurs`}
          filterComponent={
            <>
              <FilterUtilisateurs />
            </>
          }
          initialFilterValues={initialFilterValues}
          filterValuesToVariable={filterValuesToVariable}
          columns={[
            {
              Header: "Identifiant",
              accessor: "username",
              sortField: "username",
            },
            {
              Header: "Rôles",
              accessor: ({ listRole }: { listRole: RoleEntity[] }) => {
                return { listRole };
              },
              // eslint-disable-next-line react/display-name
              Cell: (row) => {
                return (
                  <div>
                    {row.value.listRole
                      .map((e: RoleEntity) => e.roleLibelle)
                      .join(", ")}
                  </div>
                );
              },
              sortField: "roleUtilisateur",
            },
            ...(user.isAdministrateur
              ? [
                  EditColumn({
                    to: (utilisateurId) =>
                      URLS.UPDATE_ROLE_UTILISATEUR(utilisateurId),
                    title: true,
                    accessor: "utilisateurId",
                    canEditFunction: (value) => {
                      return user.idUtilisateur === value ? false : true;
                    },
                  }),

                  ActiveDesactiveColumn({
                    path: url`/api/utilisateurs/inactif/`,
                    title: true,
                    headerActif: "Désactiver l'utilisateur",
                    headerInactif: "Activer l'utilisateur",
                    contentActif:
                      "Voulez-vous vraiment désactiver cet utilisateur ?",
                    contentInactif:
                      "Voulez-vous vraiment activer cet utilisateur ?",
                    canDesactiveFunction: (value) => {
                      return user.idUtilisateur === value ? false : true;
                    },
                    accessor: "utilisateurId",
                  }),
                ]
              : []),
          ]}
        />
      </PageContent>
    </>
  );
};

export default ListUtilisateurs;
